export const checkIfUserWasCorrect = (
  user: string,
  answers: questionInDB,
  correct: string | number,
  options?: string[]
) => {
  let correctIndex = 0
  let userWasCorrect = false
  let userAnswer = typeof correct === 'number' ? +user.replace('_', '.') : user

  if (options) {
    correctIndex = options.indexOf(correct.toString())
    userWasCorrect = Object.keys(answers)[correctIndex] === user
  } else {
    userWasCorrect = userAnswer === correct
  }

  return userWasCorrect
}
export const sumReduce = (accumulator: number, currentValue: number) =>
  accumulator + currentValue
export const toPercent = (val: number, total: number) =>
  +((val * 100) / total).toFixed(1)

//
//
//
type answersType = { [key: string]: number }
//
let keyToNumber = (k: string) => +k.replace('_', '.')
//
const answersToArray = (answers: answersType) => {
  let arr: [number, number][] = []
  Object.keys(answers).forEach(k => {
    arr.push([keyToNumber(k), answers[k]])
  })
  return arr.sort((a, b) => a[0] - b[0])
}
//
export const voteQuality = (
  range: [number, number],
  correct: number,
  user: number
) => {
  const maxDif = getSpan(range[0], range[1])
  const userDif = getSpan(correct, user)
  const percentOff = (userDif * 100) / maxDif
  const words = convertDifferenceToWords(percentOff)
  return { percentOff, words }
}
export const voteComparison = (
  answers: questionInDB,
  correct: number,
  user: number
) => {
  let answersArr = answersToArray(answers)
  //
  let between = votesBetween(answersArr, correct, user)
  let closer = votesCloser(answersArr, correct, user)
  let further = votesFurther(answersArr, correct, user)
  let same = votesSame(answersArr, correct, user)
  //
  return { between, closer, further, same }
}
const getSpan = (a: number, b: number) => {
  return Math.max(a, b) - Math.min(a, b)
}
const votesBetween = (
  answers: [number, number][],
  correct: number,
  guess: number
) => {
  const total = answers.reduce((a, b) => a + b[1], 0)
  const details = answers.filter(f => {
    if (correct > guess) {
      if (f[0] > guess && f[0] < correct) return f
    }
    if (correct < guess) {
      if (f[0] < guess && f[0] > correct) return f
    }
    if (correct === guess) {
      if (f[0] === guess && f[0] === correct) return f
    }
  })
  return { ...sumAndShare(details, total), details }
}
const votesCloser = (
  answers: [number, number][],
  correct: number,
  guess: number
) => {
  const total = answers.reduce((a, b) => a + b[1], 0)
  const diff = Math.abs(correct - guess)
  const details = answers.filter(f => Math.abs(f[0] - correct) < diff)
  return { ...sumAndShare(details, total), details }
}
const votesFurther = (
  answers: [number, number][],
  correct: number,
  guess: number
) => {
  const total = answers.reduce((a, b) => a + b[1], 0)
  const diff = Math.abs(correct - guess)
  const details = answers.filter(f => Math.abs(f[0] - correct) > diff)
  return { ...sumAndShare(details, total), details }
}
const votesSame = (
  answers: [number, number][],
  correct: number,
  guess: number
) => {
  const total = answers.reduce((a, b) => a + b[1], 0)
  const diff = Math.abs(correct - guess)
  const details = answers.filter(f => Math.abs(f[0] - correct) === diff)
  return { ...sumAndShare(details, total), details }
}
const sumAndShare = (answers: [number, number][], total: number) => {
  const sum = answers.reduce((a, b) => a + b[1], 0)
  const share = +((sum * 100) / total).toFixed(1)
  return { sum, share, words: convertPercentToWords(share) }
}

declare global {
  interface Number {
    between: (a: number, b: number, c?: boolean) => boolean
  }
}
Number.prototype.between = function(a: number, b: number, inclusive?: boolean) {
  var min = Math.min(a, b),
    max = Math.max(a, b)
  return inclusive ? this >= min && this <= max : this > min && this < max
}
export const convertDifferenceToWords = (difference: number) => {
  const words = [
    [0, 5, 'Sehr gut!'],
    [6, 10, 'Knapp daneben!'],
    [11, 25, 'Nicht schlecht!'],
    [26, 70, 'Leider falsch!'],
    [71, 100, 'Oje! Voll daneben.']
  ]
  let el = words.find(f => Math.round(difference).between(+f[0], +f[1], true))
  return el ? el[2] : ''
}
export const convertPercentToWords = (
  percent: number,
  toUppercase?: boolean
) => {
  const words: [number, number, string][] = [
    [0, 20, 'weniger als ein Viertel'],
    [20, 24, 'knapp ein Viertel'],
    [25, 25, 'ein Viertel'],
    [26, 29, 'mehr als ein Viertel'],
    [30, 32, 'knapp ein Drittel'],
    [33, 33, 'ein Drittel'],
    [34, 44, 'mehr als ein Drittel'],
    [45, 49, 'knapp die Hälfte'],
    [50, 50, 'die Hälfte'],
    [51, 60, 'mehr als die Hälfte'],
    [61, 64, 'knapp zwei Drittel'],
    [66, 66, 'zwei Drittel'],
    [67, 69, 'mehr als Zwei Drittel'],
    [70, 74, 'knapp drei Viertel'],
    [75, 75, 'drei Viertel'],
    [76, 85, 'mehr als drei Viertel'],
    [86, 100, 'fast alle']
  ]
  let el = words.find(f => Math.round(percent).between(+f[0], +f[1], true))
  let ret = ''
  if (el && el[2]) ret = el[2]
  if (toUppercase) ret = capitalize(ret)
  return ret
}
export const capitalize = (s: string) => {
  if (typeof s !== 'string') return ''
  return s.charAt(0).toUpperCase() + s.slice(1)
}
/**
 *
 *   0 - 20 Weniger als ein Viertel
 *  20 - 24 Knapp ein Viertel
 *  25 - 25 Ein Viertel
 *  26 - 29 Mehr als ein Viertel
 *  30 - 32 Knapp ein Drittel
 *  33 - 33 Ein Drittel
 *  34 - 44 Mehr als ein Drittel
 *  45 - 49 Knapp die Hälfte
 *  50 - 50 Die Hälfte
 *  51 - 60 Mehr als die Hälfte
 *  61 - 64 Knapp zwei Drittel
 *  66 - 66 Zwei Drittel
 *  67 - 69 Mehr als Zwei Drittel
 *  70 - 74 Knapp drei Viertel
 *  75 - 75 Drei Viertel
 *  76 - 85 Mehr als drei Viertel
 *  86 - 100 Fast alle
 *
 */
